// App-wide password policy — must stay identical to backend validate_password_strength().
// Min 8 characters AND at least one uppercase, lowercase, number, and special character.

export const PASSWORD_POLICY_TEXT =
  'Minimum 8 characters with at least one uppercase letter, one lowercase letter, a number and a special character.';

export const getPasswordChecks = (pw = '') => ({
  length: typeof pw === 'string' && pw.length >= 8,
  upper: /[A-Z]/.test(pw || ''),
  lower: /[a-z]/.test(pw || ''),
  number: /\d/.test(pw || ''),
  special: /[^A-Za-z0-9]/.test(pw || ''),
});

export const isPasswordValid = (pw = '') => Object.values(getPasswordChecks(pw)).every(Boolean);

export const PASSWORD_RULES = [
  { key: 'length', label: 'At least 8 characters' },
  { key: 'upper', label: 'One uppercase letter' },
  { key: 'lower', label: 'One lowercase letter' },
  { key: 'number', label: 'One number' },
  { key: 'special', label: 'One special character' },
];
